import { useSelector } from 'react-redux'
import './CampgroundImage.scss'

const CampgroundImage = () => {
  const imageAlt = useSelector(state => state.campground.imageAlt)
  const pictureUrl = useSelector(state => state.campground.pictureUrl)

  return (
    <img alt={imageAlt} className="resdetails--campground-image d-none d-lg-block w-100" src={pictureUrl} />
  )
}

export default CampgroundImage
